import Dialog from '../../shared/dialog/dialog';
import React from 'react';

export default function ErrorDialog({ onClose, error, children }) {
  const description = (
    <span className="tpg_b1">
      Please contact us and we’ll be happy to help – 0344 257 0345 or email{' '}
      <a href="mailto:team247@doctorcall.co.uk">team247@doctorcall.co.uk</a>. Telephone and video consultations are also
      available to book online now.
    </span>
  );

  return (
    <Dialog onClose={onClose} className="booking__modal">
      <div className="booking__dialog-content">
        <span className="tpg_a3 booking__dialog-content-title">{error}</span>
        {children || description}
      </div>
    </Dialog>
  );
}
